// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__PWfNz","icon":"Chip_icon__35zTP","iconImage":"Chip_iconImage__q7i0E","selected":"Chip_selected__W1bMx","disabled":"Chip_disabled__Mi0WK"};